import { getV2HomeUrl } from 'constants/routes';
import localStorageConstants from 'constants/localStorage';

const QUERY_PARAM_KEY_CLIENT_ID = 'clientId';
const QUERY_PARAM_KEY_AUTH_DOMAIN = 'authDomain';

export type AuthConfig = {
  clientId: string;
  authDomain: string;
};

export const redirectToLoginPage = () => {
  window.location.href = `${
    window.REACT_APP_MM_BASE_CORE_URL
  }/accounts/login/app/${
    window.REACT_APP_MM_APP_ID
  }?redirectTo=${getV2HomeUrl()}`;
};

export const saveAuthConfigFromQueryParamsAndRemoveAuthConfigQueryParamsIfAny =
  () => {
    const queryParams = new URLSearchParams(window.location.search);
    let hasChangedQueryParams = false;

    const clientId = queryParams.get(QUERY_PARAM_KEY_CLIENT_ID);
    if (clientId) {
      localStorage.setItem(localStorageConstants.USER_IAM_CLIENT_ID, clientId);
      queryParams.delete(QUERY_PARAM_KEY_CLIENT_ID);
      hasChangedQueryParams = true;
    }

    const authDomain = queryParams.get(QUERY_PARAM_KEY_AUTH_DOMAIN);
    if (authDomain) {
      localStorage.setItem(localStorageConstants.USER_AUTH_DOMAIN, authDomain);
      queryParams.delete(QUERY_PARAM_KEY_AUTH_DOMAIN);
      hasChangedQueryParams = true;
    }

    if (hasChangedQueryParams) {
      let newUrl = `${window.location.origin}${window.location.pathname}`;
      if (queryParams.entries.length !== 0) {
        newUrl += `?${queryParams.toString()}`;
      }
      window.location.replace(newUrl);
    }
  };

export const getAuthConfig = (): AuthConfig | null => {
  const clientId = localStorage.getItem(
    localStorageConstants.USER_IAM_CLIENT_ID
  );
  const authDomain = localStorage.getItem(
    localStorageConstants.USER_AUTH_DOMAIN
  );

  if (!clientId || !authDomain) {
    return null;
  }

  return {
    clientId,
    authDomain,
  };
};

export const clearAuthConfig = () => {
  localStorage.removeItem(localStorageConstants.USER_IAM_CLIENT_ID);
  localStorage.removeItem(localStorageConstants.USER_AUTH_DOMAIN);
};
